export default "__VITE_ASSET__CmBxQtDF__"